export default __webpack_public_path__ + "static/media/JsIcon.5648ae0a.png";